// extracted by mini-css-extract-plugin
export default {"sectionHeading":"sectionHeading_sectionHeading__JdRA3"};